import React from 'react';
import { Globe, Users, Lock } from 'lucide-react';
import { useTranslation } from '../../i18n';
import { TEMPLATE_BY_ID } from './templates';
import './MyStory.css';

function excerpt(html, n = 150) {
  const txt = (html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  return txt.length > n ? `${txt.slice(0, n).trim()}…` : txt;
}

const VIS_ICON = { public: Globe, connections: Users, private: Lock };

// One story as a card. Tapping it opens the story (read view, or the editor for
// a draft) — there are no inline edit/delete buttons. Used on the My Story list
// and on profiles. Accent + icon come from the template.
export default function StoryCard({ story, onOpen, showVisibility = true }) {
  const { t } = useTranslation('testimony');
  const tpl = TEMPLATE_BY_ID[story.template] || TEMPLATE_BY_ID.freeform;
  const Icon = tpl.Icon;
  const accent = story.color || tpl.color;
  const VisIcon = VIS_ICON[story.visibility] || Lock;
  const isDraft = !story.combinedHtml;

  return (
    <div className="sc-card card" onClick={() => onOpen && onOpen(story)} role={onOpen ? 'button' : undefined} tabIndex={onOpen ? 0 : undefined}>
      <div className={`sc-accent${story.coverImage ? ' sc-accent--img' : ''}`} style={{ background: accent }}>
        {story.coverImage
          ? <img className="sc-cover-img" src={story.coverImage} alt="" loading="lazy" />
          : <Icon size={26} color="#fff" strokeWidth={1.75} />}
      </div>
      <div className="sc-body">
        <div className="sc-head">
          <h3 className="sc-title">{story.title || t('untitled')}</h3>
          {showVisibility && (
            <span className={`sc-vis sc-vis-${story.visibility}`} title={t(`visibilityOptions.${story.visibility}.label`)}>
              <VisIcon size={11} strokeWidth={2.5} />
            </span>
          )}
        </div>
        <div className="sc-meta">
          <span className="sc-badge" style={{ color: accent, background: `${accent}1a` }}>{t(`templates.${tpl.id}.label`)}</span>
          {isDraft && <span className="sc-badge sc-badge-draft">{t('draft')}</span>}
        </div>
        {story.combinedHtml
          ? <p className="sc-excerpt">{excerpt(story.combinedHtml)}</p>
          : <p className="sc-excerpt sc-excerpt-empty">{t('draftEmpty')}</p>}
      </div>
    </div>
  );
}
